import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReceiptFormScreen } from '@/features/purchasing-receipts/receipt-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the goods receipt form (plan screen 3), a sibling of
 * `orders.$orderId.index.tsx` under `orders.tsx`'s own Outlet.
 */
export const Route = createFileRoute('/_authenticated/purchasing/orders/$orderId/receive')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'goods_receipt.create')) {
      throw redirect({ to: '/purchasing/orders/$orderId', params: { orderId: params.orderId } })
    }
  },
  component: PurchaseOrderReceiveRoute,
})

function PurchaseOrderReceiveRoute() {
  const { orderId } = Route.useParams()

  return <ReceiptFormScreen orderId={orderId} />
}
